import React, { useEffect, useState } from "react";
import axiosInstance from "../AxiosInstance";
import { Pencil, Trash2 } from "lucide-react";
import UserDialog from "./Dialog/AddUserDialog";
import EditUserDialog from "./Dialog/UserEditDialog";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleDeleteUser = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await axiosInstance.post(`/users/status`, null, {
          params: {
            id: id,
            status: "DELETED",
          },
        });
  
        // Refetch the users after status update
        fetchUsers();
      } catch (error) {
        console.error("Error updating user status:", error);
        alert("Failed to update user status. Please try again.");
      }
    }
  };
  


  const fetchUsers = async () => {
    try {
      const response = await axiosInstance.get("/users?page=0&size=10");
      const usersData = response.data?.data?.data || [];
  
      // Filter only ACTIVE users
      const activeUsers = usersData.filter(user => user.status === "ACTIVE");
  
      setUsers(activeUsers);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleAddUserClick = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleEditDialogClose = () => {
    setIsEditDialogOpen(false);
  };

  const handleSubmitSuccess = (newUser) => {
    // Option 1: Re-fetch the list
    // fetchUsers();

    // Option 2: Update the list locally
    setUsers((prevUsers) => [newUser, ...prevUsers]);
  };



  const handleEditClick = (user) => {
    setSelectedUser(user);
    setIsEditDialogOpen(true);
  };

  const handleEditSubmitSuccess = () => {
    fetchUsers();
    setIsEditDialogOpen(false);
    setSelectedUser(null);
  };

  return (
    <div className="p-6">
      {/* Add User Button */}
      <div className="mb-6">
        <button
          onClick={handleAddUserClick}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2"
        >
          <span>ADD USER</span>
        </button>
      </div>

      {/* Add User Dialog */}
      <UserDialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        onSubmitSuccess={handleSubmitSuccess}
        fetchUsers={fetchUsers}
      />

      <EditUserDialog
        open={isEditDialogOpen}
        onClose={handleEditDialogClose}
        onSubmitSuccess={handleEditSubmitSuccess}
        fetchUsers={fetchUsers}
        initialUserData={selectedUser} // Pass selected user here
      />


      {/* User Cards */}
      <div className="flex flex-wrap gap-4">
        {users.length > 0 ? (
          users.map((user) => (
            <div
              key={user.id}
              className="w-72 h-auto bg-white dark:bg-gray-800 shadow-md rounded-lg p-4 flex flex-col justify-between border border-gray-300 dark:border-gray-700 transition-all duration-300"
            >
              <div>
                <p className="text-sm font-bold text-gray-700 dark:text-gray-200">
                  ID: <span className="font-normal">{user.id}</span>
                </p>
                <p className="text-sm font-bold text-gray-700 dark:text-gray-200">
                  Name: <span className="font-normal">{user.name}</span>
                </p>
                <p className="text-sm font-bold text-gray-700 dark:text-gray-200">
                  Email: <span className="font-normal">{user.email}</span>
                </p>
                <p className="text-sm font-bold text-gray-700 dark:text-gray-200">
                  PhoneNumber: <span className="font-normal">{user.phoneNumber}</span>
                </p>
              </div>

              <p
                className={`text-sm font-semibold mt-2 ${user.status?.toLowerCase() === "active"
                  ? "text-green-600 dark:text-green-400"
                  : "text-red-500 dark:text-red-400"
                  }`}
              >
                Status: {user.status}
              </p>

              {/* Action Icons */}
              <div className="flex justify-end gap-3 mt-4">
                <button
                  onClick={() => handleEditClick(user)}
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
                >
                  <Pencil size={18} />
                </button>

                <button
                  onClick={() => handleDeleteUser(user.id)}
                  className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300"
                >
                  <Trash2 size={18} />
                </button>

              </div>
            </div>
          ))
        ) : (
          <p>No users found.</p>
        )}
      </div>
    </div>
  );
};

export default Users;
